'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTimes, iconTimesTag } from '@ni/nimble-components/dist/esm/icons/times';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTimes };
export { iconTimesTag };
export const NimbleIconTimes = wrap(IconTimes);